// Messages for operator/shipments/ShipmentFormModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.shipment_form.mode.ship': 'Ocean',
  'operator.shipment_form.mode.air': 'Air',
  'operator.shipment_form.mode.truck': 'Truck',
  'operator.shipment_form.mode.train': 'Rail',
  'operator.shipment_form.title.edit': 'Edit shipment',
  'operator.shipment_form.title.create': 'Create shipment',
  'operator.shipment_form.cancel': 'Cancel',
  'operator.shipment_form.save_changes': 'Save changes',
  'operator.shipment_form.create': 'Create shipment',
  'operator.shipment_form.section.parties': 'Parties & mode',
  'operator.shipment_form.field.customer': 'Customer',
  'operator.shipment_form.customer_aria': 'Customer',
  'operator.shipment_form.customer_placeholder': 'Select a customer',
  'operator.shipment_form.field.mode': 'Mode',
  'operator.shipment_form.mode_aria': 'Mode',
  'operator.shipment_form.mode_placeholder': 'Select a mode',
  'operator.shipment_form.field.service': 'Service',
  'operator.shipment_form.service_aria': 'Service',
  'operator.shipment_form.service_placeholder': 'Select a service',
  'operator.shipment_form.field.incoterm': 'Incoterm',
  'operator.shipment_form.incoterm_aria': 'Incoterm',
  'operator.shipment_form.incoterm_placeholder': 'Select an incoterm',
  'operator.shipment_form.field.carrier': 'Carrier',
  'operator.shipment_form.carrier_aria': 'Carrier',
  'operator.shipment_form.carrier_placeholder': 'Select a carrier',
  'operator.shipment_form.field.consignee': 'Consignee',
  'operator.shipment_form.section.references': 'References',
  'operator.shipment_form.field.mbl': 'Master B/L (MBL)',
  'operator.shipment_form.field.hbl': 'House B/L (HBL)',
  'operator.shipment_form.field.po': 'Customer PO #',
  'operator.shipment_form.field.booking': 'Booking #',
  'operator.shipment_form.section.routing': 'Routing & dates',
  'operator.shipment_form.field.loading_port': 'Loading port',
  'operator.shipment_form.loading_port_aria': 'Loading port',
  'operator.shipment_form.field.final_destination': 'Final destination',
  'operator.shipment_form.final_destination_aria': 'Final destination',
  'operator.shipment_form.location_placeholder': 'Search ports, airports, cities…',
  'operator.shipment_form.field.etd': 'ETD',
  'operator.shipment_form.etd_aria': 'ETD',
  'operator.shipment_form.field.eta': 'ETA (to port)',
  'operator.shipment_form.eta_aria': 'ETA to port',
  'operator.shipment_form.field.pos': 'Purchase orders',
  'operator.shipment_form.pos_placeholder': 'Add a PO, press Enter…',
  'operator.shipment_form.remove_po': 'Remove PO',
  'operator.shipment_form.field.vessel': 'Vessel',
  'operator.shipment_form.field.voyage': 'Voyage',
  'operator.shipment_form.field.discharge_port': 'Discharge port',
  'operator.shipment_form.discharge_port_aria': 'Discharge port',
  'operator.shipment_form.field.origin_location': 'Origin location',
  'operator.shipment_form.origin_location_aria': 'Origin location',
  'operator.shipment_form.field.etc': 'ETC',
  'operator.shipment_form.etc_aria': 'ETC',
  'operator.shipment_form.field.eta_final_destination': 'ETA to final destination',
  'operator.shipment_form.eta_final_aria': 'ETA to final destination',
  'operator.shipment_form.field.ata': 'ATA date',
  'operator.shipment_form.ata_aria': 'ATA date',
  'operator.shipment_form.field.final_delivery': 'Final delivery date',
  'operator.shipment_form.final_delivery_aria': 'Final delivery date',
  'operator.shipment_form.section.cargo': 'Cargo',
  'operator.shipment_form.field.weight': 'Gross weight (kg)',
  'operator.shipment_form.field.volume': 'Volume (CBM)',
  'operator.shipment_form.field.containers': 'Containers',
  'operator.shipment_form.location_create': 'Create "{name}"',
  'operator.shipment_form.error_summary': "This shipment couldn't be saved:",
}

export const zhTW = {
  'operator.shipment_form.mode.ship': '海運',
  'operator.shipment_form.mode.air': '空運',
  'operator.shipment_form.mode.truck': '卡車',
  'operator.shipment_form.mode.train': '鐵路',
  'operator.shipment_form.title.edit': '編輯貨件',
  'operator.shipment_form.title.create': '建立貨件',
  'operator.shipment_form.cancel': '取消',
  'operator.shipment_form.save_changes': '儲存變更',
  'operator.shipment_form.create': '建立貨件',
  'operator.shipment_form.section.parties': '相關方與運輸方式',
  'operator.shipment_form.field.customer': '客戶',
  'operator.shipment_form.customer_aria': '客戶',
  'operator.shipment_form.customer_placeholder': '選擇客戶',
  'operator.shipment_form.field.mode': '運輸方式',
  'operator.shipment_form.mode_aria': '運輸方式',
  'operator.shipment_form.mode_placeholder': '選擇運輸方式',
  'operator.shipment_form.field.service': '服務',
  'operator.shipment_form.service_aria': '服務',
  'operator.shipment_form.service_placeholder': '選擇服務',
  'operator.shipment_form.field.incoterm': '貿易條件',
  'operator.shipment_form.incoterm_aria': '貿易條件',
  'operator.shipment_form.incoterm_placeholder': '選擇貿易條件',
  'operator.shipment_form.field.carrier': '承運商',
  'operator.shipment_form.carrier_aria': '承運商',
  'operator.shipment_form.carrier_placeholder': '選擇承運商',
  'operator.shipment_form.field.consignee': '收貨人',
  'operator.shipment_form.section.references': '參考編號',
  'operator.shipment_form.field.mbl': '主提單 (MBL)',
  'operator.shipment_form.field.hbl': '分提單 (HBL)',
  'operator.shipment_form.field.po': '客戶採購單號',
  'operator.shipment_form.field.booking': '訂艙編號',
  'operator.shipment_form.section.routing': '路線與日期',
  'operator.shipment_form.field.loading_port': '裝貨港',
  'operator.shipment_form.loading_port_aria': '裝貨港',
  'operator.shipment_form.field.final_destination': '最終目的地',
  'operator.shipment_form.location_placeholder': '搜尋港口、機場、城市…',
  'operator.shipment_form.final_destination_aria': '最終目的地',
  'operator.shipment_form.field.etd': 'ETD',
  'operator.shipment_form.etd_aria': 'ETD',
  'operator.shipment_form.field.eta': 'ETA（到港）',
  'operator.shipment_form.eta_aria': '預計到港',
  'operator.shipment_form.field.pos': '採購單',
  'operator.shipment_form.pos_placeholder': '輸入採購單後按 Enter…',
  'operator.shipment_form.remove_po': '移除採購單',
  'operator.shipment_form.field.vessel': '船名',
  'operator.shipment_form.field.voyage': '航次',
  'operator.shipment_form.field.discharge_port': '卸貨港',
  'operator.shipment_form.discharge_port_aria': '卸貨港',
  'operator.shipment_form.field.origin_location': '起運地',
  'operator.shipment_form.origin_location_aria': '起運地',
  'operator.shipment_form.field.etc': 'ETC',
  'operator.shipment_form.etc_aria': 'ETC',
  'operator.shipment_form.field.eta_final_destination': '預計到達最終目的地',
  'operator.shipment_form.eta_final_aria': '預計到達最終目的地',
  'operator.shipment_form.field.ata': 'ATA 日期',
  'operator.shipment_form.ata_aria': 'ATA 日期',
  'operator.shipment_form.field.final_delivery': '最終送達日期',
  'operator.shipment_form.final_delivery_aria': '最終送達日期',
  'operator.shipment_form.section.cargo': '貨物',
  'operator.shipment_form.field.weight': '毛重 (kg)',
  'operator.shipment_form.field.volume': '體積 (CBM)',
  'operator.shipment_form.field.containers': '貨櫃',
  'operator.shipment_form.location_create': '新增「{name}」',
  'operator.shipment_form.error_summary': '無法儲存此貨件：',
}
